import type { DLClickEventProps, DLProductEventProps, ProductProps } from 'tsconfig/types';
import { adobeDataLayer } from './AdobeDataLayer';
import { adobeProductMapData } from './adobeProductMapData';

// Define constants for repeated strings
const ADD_TO_CART = 'add to cart';
const UPDATE_CART = 'update cart';
const ADD_TO_BASKET_TEXT = 'Add to Basket';
const SUBSCRIBE_AND_SAVE_LOCATION = 'Cart';
const ADD_SUBSCRIBE_SAVE = 'Add Subscribe and Save';

export const handleDLProductClickEvent = (
  clickType: string,
  productData: ProductProps,
  quantity: number,
  page?: string,
  productItemCode?: string,
) => {
  const isArray = Array.isArray(productData);
  const products: ProductProps[] = isArray ? productData : [productData];

  const productDetailInfo = products
    .map(product => {
      if (!product || !Array.isArray(product.skus) || product.skus.length === 0) {
        return null;
      }
      const productSkus = product.skus;

      const matchingSku = productSkus.find(sku => sku.itemCode === productItemCode) || productSkus[0];

      const mappedData = adobeProductMapData(product, quantity, matchingSku?.itemCode);

      const price =
        product.enPrimeur || product.enPrimeurFlag ? productSkus[0]?.enPrimeurPrice : matchingSku?.salePrice || 0;

      return {
        ...mappedData,
        itemcode: matchingSku?.itemCode ?? productItemCode,
        price,
        quantity,
        noBottles: matchingSku?.numberOfBottles,
      };
    })
    .filter(Boolean);

  const PAGE_TYPE = adobeDataLayer.getPageType();
  const isSubscribeSaveOverlay = page?.includes('subscribeSave_overlay');

  // Object for cart page
  const addToCartClick: DLClickEventProps = {
    clickAction: UPDATE_CART,
    clickDescription: `${PAGE_TYPE}:${UPDATE_CART}`,
    clickLocation: `${PAGE_TYPE}`,
    clickName: UPDATE_CART,
    clickText: 'add',
    errorMessage: '',
  };

  // Object for PDP pages
  const productAddToCartClick: DLClickEventProps = {
    clickAction: ADD_TO_CART,
    clickDescription: `${PAGE_TYPE}:${ADD_TO_CART}`,
    clickLocation: `${PAGE_TYPE}`,
    clickName: ADD_TO_CART,
    clickText: ADD_TO_BASKET_TEXT,
    errorMessage: '',
  };

  // Object for Initiating cart
  const clickInitiateCart: DLClickEventProps = {
    clickAction: 'add to empty cart',
    clickDescription: `${PAGE_TYPE}:add to empty cart`,
    clickLocation: `${PAGE_TYPE}`,
    clickName: 'add to empty cart',
    clickText: ADD_TO_BASKET_TEXT,
    errorMessage: '',
  };

  // Object for cart page remove
  const clickRemoveFromCart: DLClickEventProps = {
    clickAction: UPDATE_CART,
    clickDescription: `${PAGE_TYPE}:${UPDATE_CART}`,
    clickLocation: `${PAGE_TYPE}`,
    clickName: UPDATE_CART,
    clickText: 'remove',
    errorMessage: '',
  };

  // Object for mini cart page
  const addToCartMiniCartClick: DLClickEventProps = {
    clickAction: ADD_TO_CART,
    clickDescription: `${PAGE_TYPE}:${ADD_TO_CART}`,
    clickLocation: 'mini-cart',
    clickName: ADD_TO_CART,
    clickText: ADD_TO_CART,
    errorMessage: '',
  };

  // Object for Subscribe and Save - Add to Cart
  const addToCartSubscribeSaveClick: DLClickEventProps = {
    clickAction: ADD_SUBSCRIBE_SAVE,
    clickDescription: `${SUBSCRIBE_AND_SAVE_LOCATION}:${ADD_SUBSCRIBE_SAVE}${isSubscribeSaveOverlay ? ' Overlay' : ''}`,
    clickLocation: SUBSCRIBE_AND_SAVE_LOCATION,
    clickName: ADD_SUBSCRIBE_SAVE,
    clickText: !isSubscribeSaveOverlay ? 'Subscribe and Add to Basket' : ADD_SUBSCRIBE_SAVE,
  };

  // Object for Subscribe and Save - Product
  const PDPSubscribeSaveClick: DLClickEventProps = {
    clickDescription: `Product:${ADD_SUBSCRIBE_SAVE} ${page === 'overlay' ? 'Overlay' : ''}`,
    clickName: ADD_SUBSCRIBE_SAVE,
    clickLocation: 'Product',
    clickText: `${page === 'overlay' ? ADD_SUBSCRIBE_SAVE : 'Subscribe and Add to Basket'}`,
    clickAction: ADD_SUBSCRIBE_SAVE,
  };

  let click: DLClickEventProps = {};

  const product: DLProductEventProps | DLProductEventProps[] = isArray
    ? productDetailInfo.map(item => ({
        ...item,
      }))
    : {
        ...productDetailInfo,
        quantity,
        itemcode: productItemCode,
        price: productDetailInfo?.[0]?.price,
      };

  let addToCartClickType;

  if (page === 'cart') {
    addToCartClickType = addToCartClick;
  } else if (page === 'miniCart') {
    addToCartClickType = addToCartMiniCartClick;
  } else {
    addToCartClickType = productAddToCartClick;
  }

  switch (clickType) {
    case 'InitiateCart':
      click = clickInitiateCart;
      break;
    case 'addToCart':
      click = addToCartClickType;
      break;
    case 'removeFromCart':
      click = clickRemoveFromCart;
      break;
    case 'SubscribeSaveCart':
      click = addToCartSubscribeSaveClick;
      break;
    case 'SubscribeSaveProduct':
      click = PDPSubscribeSaveClick;
      break;
    default:
      return;
  }
  adobeDataLayer.clickEvent(clickType, click, {
    product,
  });
};
